import * as actionTypes from '../actions/actionTypes';
import * as actions from './index';

export const updateAppObjectsSuccess = (data) => {
    return {
        type: actionTypes.APP_UPDATE_APPOBJECTS_SUCCESS,
        payload: data
    }
}

export const updateAppObjects = (obj) => {
    return (dispatch) => {
        dispatch(actions.updateAppObjectsSuccess(obj));
    }
}
